import { formatMoney, Item } from '@nemuru-eng/js-api-client';

import { OrderLineInAction } from '../../../types/OrderLineInAction';
import {getItemTooltip} from './getOrderActions/utils/getItemTooltip';

export const transformItemToOrderLineInAction = (item: Item, currency) =>
  ({
    id: item.id,
    name: item.article.name,
    amount: { value: item.totalPriceWithTax, currency },
    infoText: `${formatMoney({ value: item.article.unitPriceWithTax, currency: currency })} x ${item.units}`,
    tooltip: getItemTooltip(item),
  } as OrderLineInAction);

